import { UploadCloud } from "lucide-react";
import React from "react";
import { useDropzone } from "react-dropzone";

import { cn } from "@/lib/utils";

interface ICampaignUploadDropzoneProps {
  onFileSelected: (file: File | null) => void;
  selectedFile: File | null;
  disabled?: boolean;
  title: string;
  description: string;
}

export const CampaignUploadDropzone: React.FC<ICampaignUploadDropzoneProps> = ({
  onFileSelected,
  selectedFile,
  disabled = false,
  title,
  description,
}) => {
  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      const [firstFile] = acceptedFiles;
      onFileSelected(firstFile ?? null);
    },
    [onFileSelected]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    disabled,
    accept: {
      "text/csv": [".csv"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
      "application/vnd.ms-excel": [".csv"],
    },
  });

  return (
    <div
      {...getRootProps()}
      className={cn(
        "rounded-lg border-2 border-dashed p-6 text-center transition-colors cursor-pointer",
        isDragActive
          ? "border-primary bg-primary/5"
          : "border-border hover:border-primary/60",
        disabled && "opacity-60 cursor-not-allowed"
      )}
    >
      <input {...getInputProps()} />
      <div className="flex flex-col items-center gap-2">
        <UploadCloud className="h-8 w-8 text-primary" />
        <p className="text-sm font-medium">{title}</p>
        <p className="text-xs text-muted-foreground">{description}</p>
        {selectedFile && (
          <p className="text-sm text-foreground font-medium">{selectedFile.name}</p>
        )}
      </div>
    </div>
  );
};
